const state = {
  isGlobalMenuOpen: false,
  isCategoryLockOpen: false,
  isQuestionLockOpen: false,
  isBridalItemGroupMenuOpen: false
}

const getters = {
  isSideMenuOpen: state => (
    state.isGlobalMenuOpen || state.isCategoryLockOpen || state.isQuestionLockOpen || state.isBridalItemGroupMenuOpen
  )
}

const mutations = {
  toggleGlobalMenu(state) {
    if (this.state.app.loading) {
      return false
    }

    state.isGlobalMenuOpen = !state.isGlobalMenuOpen

    if (state.isGlobalMenuOpen) {
      state.isCategoryLockOpen = false
      state.isQuestionLockOpen = false
      state.isBridalItemGroupMenuOpen = false
    }
  },
  toggleCategoryLock(state) {
    state.isCategoryLockOpen = !state.isCategoryLockOpen

    if (state.isCategoryLockOpen) {
      state.isGlobalMenuOpen = false
    }
  },
  toggleQuestionLock(state) {
    state.isQuestionLockOpen = !state.isQuestionLockOpen

    if (state.isQuestionLockOpen) {
      state.isGlobalMenuOpen = false
    }
  },
  toggleBridalItemGroupMenu(state) {
    state.isBridalItemGroupMenuOpen = !state.isBridalItemGroupMenuOpen

    if (state.isBridalItemGroupMenuOpen) {
      state.isGlobalMenuOpen = false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
